var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control-logo"},[_vm._v("\n    省市县一体融媒体管理平台\n")])}
var staticRenderFns = []

export { render, staticRenderFns }